import React from 'react';
import { Modal } from '../Core';
import { QuestionMarkCircleIcon } from '../../../assets/icons';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    confirmVariant?: 'primary' | 'secondary' | 'danger';
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmVariant = 'danger',
}) => {
    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            hideHeader={true}
            variant="standard"
            className="max-w-md w-full"
            dialogClassName="z-[9999]"
        >
            <div className="flex flex-col items-center justify-center p-8 text-center bg-white rounded-3xl">
                <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center text-red-500 mb-6">
                    <QuestionMarkCircleIcon className="w-8 h-8" />
                </div>

                <h3 className="text-xl font-black text-darkGreen uppercase tracking-tight mb-3">
                    {title}
                </h3>

                <div className="text-sm font-medium text-gray-500 mb-8 leading-relaxed">
                    {message}
                </div>

                <div className="flex items-center gap-4 w-full">
                    <button
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClose();
                        }}
                        className="flex-1 py-4 bg-gray-50 text-gray-500 text-[11px] font-black uppercase tracking-[0.2em] rounded-2xl hover:bg-gray-100 hover:text-darkGreen transition-all duration-200 cursor-pointer"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onConfirm();
                        }}
                        className={`flex-1 py-4 text-white text-[11px] font-black uppercase tracking-[0.2em] rounded-2xl shadow-lg transition-all duration-200 active:scale-95 cursor-pointer ${ confirmVariant === 'danger'
                            ? 'bg-red-500 shadow-red-500/20 hover:bg-red-600 hover:shadow-red-500/30'
                            : confirmVariant === 'primary'
                                ? 'bg-primaryGreen shadow-primaryGreen/20 hover:bg-primaryGreen/90 hover:shadow-primaryGreen/30'
                                : 'bg-gray-800 hover:bg-gray-900'
                            }`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
